import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop';
import { Box, Grid, Card, Container } from "@mui/material";
import Typography from "@mui/material/Typography";
import Warning from '../../assets/img/warning.png';
import Disconnected from '../../assets/img/disconnected.png';
import db from "../../firebase-config";


export default function PopupGiveawayRollout() {
    const { bu, plant, factory, line } = useParams();
    const [giveaway_rollout, setgiveaway_rollout] = useState([]);
    const [giveaway_taglist, setgiveaway_taglist] = useState([]);

    // const plant_giveaway = () => {
    //     try {
    //         const buName = bu;
    //         const plantName = plant;
    //         const factoryName = factory;
    //         const lineName = line;
    //         const lineMapping = {
    //             "แปรรูปไก่_4117_FPP2_Line7": 'Thailand411700000000000000',
    //             "แปรรูปไก่_4117_FPP2_Line8": 'Thailand411700000000000000',
    //             "แปรรูปไก่_4117_FPP2_Line9": 'Thailand411700000000000000',
    //             "แปรรูปไก่_4117_FPP2_Line10": 'Thailand411700000000000000',

    //             "แปรรูปไก่_4116_PlantB_Line4": 'Thailand411600000000000000',
    //             "แปรรูปไก่_4116_PlantB_Line5": 'Thailand411600000000000000',
    //         };
    //         const key = `${buName}_${plantName}_${factoryName}_${lineName}`;
    //         return lineMapping[key];
    //     } catch (error) {
    //         console.error("Error in line_performance:", error);
    //         return null;
    //     }
    // };

    // const factory_giveaway = () => {
    //     try {
    //         const buName = bu;
    //         const plantName = plant;
    //         const factoryName = factory;
    //         const lineName = line;
    //         const lineMapping = {
    //             "แปรรูปไก่_4117_FPP2_Line7": 'Further.4117',
    //             "แปรรูปไก่_4117_FPP2_Line8": 'Further.4117',
    //             "แปรรูปไก่_4117_FPP2_Line9": 'Further.4117',
    //             "แปรรูปไก่_4117_FPP2_Line10": 'Further.4117',

    //             "แปรรูปไก่_4116_PlantB_Line4": 'MES_Minburi.4116',
    //             "แปรรูปไก่_4116_PlantB_Line5": 'MES_Minburi.4116',
    //         };
    //         const key = `${buName}_${plantName}_${factoryName}_${lineName}`;
    //         return lineMapping[key];
    //     } catch (error) {
    //         console.error("Error in line_performance:", error);
    //         return null;
    //     }
    // };

    // const line_giveaway = () => {
    //     try {
    //         const buName = bu;
    //         const plantName = plant;
    //         const factoryName = factory;
    //         const lineName = line;
    //         const lineMapping = {
    //             "แปรรูปไก่_4117_FPP2_Line7": 'Line7',
    //             "แปรรูปไก่_4117_FPP2_Line8": 'Line8',
    //             "แปรรูปไก่_4117_FPP2_Line9": 'Line9',
    //             "แปรรูปไก่_4117_FPP2_Line10": 'Line10',

    //             "แปรรูปไก่_4116_PlantB_Line4": 'Line4',
    //             "แปรรูปไก่_4116_PlantB_Line5": 'Line5',
    //         };
    //         const key = `${buName}_${plantName}_${factoryName}_${lineName}`;
    //         return lineMapping[key];
    //     } catch (error) {
    //         console.error("Error in line_performance:", error);
    //         return null;
    //     }
    // };

    useEffect(() => {
        const docId = `${plant === 'B425' ? 'Vietnam' : 'Thailand'}${plant}${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}${line}Giveaway_V2`;
        const docRef = db.collection('prod_mes_ignition_giveaway_v2').doc(docId);

        const subscribe = docRef.onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
                setgiveaway_rollout([{ ...docSnapshot.data(), id: docSnapshot.id }][0]);
            } else {
                console.log('No such document!');
                setgiveaway_rollout([]);
            }
        });

        const subscriberGiveawayTaglist = db
            .collection("prod_mes_ignition_giveaway_v2_tag_list")
            .onSnapshot((querySnapshot) => {
                const giveawayData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setgiveaway_taglist(giveawayData);
            });
        return () => {
            subscribe();
            subscriberGiveawayTaglist();
        };
    }, []);


    const findMachine = (key) => (giveaway_taglist || []).find((a) => (a?.TAG_NAME || "").includes(key)) || null;
    const findID = (key) => (giveaway_taglist || []).find((a) => (a?.id || "").includes(key)) || null;

    const multiheadStatus = findMachine(`${plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further'}.${plant}.${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.MTH_Status`);
    const multiheadSKU = findMachine(`${plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further'}.${plant}.${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3'? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.MTH_ProductName`);
    const checkWeightStatus = findMachine(`${plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further'}.${plant}.${factory === 'FPP2' || factory === 'PlantB'|| factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.CW_Status`);
    const checkWeightSKU = findMachine(`${plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further'}.${plant}.${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.ProductName`);
    const sku = findID(`${plant === 'B425' ? 'Vietnam' : 'Thailand'}${plant}${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}${line}Giveaway_V2SAP_PO`);
    const AICameraStatus = findMachine(`${plant === '4117' ? 'Further' : plant === '4116' ? 'MES_Minburi' : plant === 'B425' ? 'MES_VN' : 'Further'}.${plant}.${factory === 'FPP2' || factory === 'PlantB' || factory === 'FPP1' || factory === 'FPP3' ? '00000000000000' : factory}.${plant === 'B425' ? 'Vietnam' : 'Thailand'}.Dashboard.GiveAway.${line}.Counter_Status`);

    //const sku_replace = sku?.SAP_SKU ? String(sku.SAP_SKU).replace(/['[\]]/gi, '') : '-';
    const sku_replace = sku?.SAP_SKU
        ? String(sku.SAP_SKU)
            .replace(/['[\]]/gi, '')
            .trim()
            .split(/\s+/)
            .join('\n')
        : '-';


    return (
        <div>
            <Backdrop
                sx={{ backgroundColor: "rgb(0, 0, 0, 0.85)", zIndex: (theme) => theme.zIndex.drawer + 1 }}

                open
            >
                <Grid
                    container spacing={1}
                    direction="row"
                    alignItems="top"
                    justifyContent="center"
                    style={{ minHeight: '60vh', maxHeight: '0vh', flexGrow: 1, paddingLeft: 25, paddingTop: 0 }}
                >

                    <Grid item lg={12} md={12} sm={12} xl={12} xs={12} style={{ position: "relative", top: '-10vw', left: '0vw', height: '1px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                            <img src={Warning} height="35px" />
                            <Typography style={{ color: '#ffffff', fontWeight: "bold", fontSize: 48, position: "relative" }} textAlign="center">
                                Online Status & Preset Setting
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid container spacing={2} style={{ position: "relative", top: '-12vw', left: '0vw' }}>
                        <Grid id="top-row" container xs={8} md={8} lg={8} xl={8} style={{ position: "relative", padding: 3 }}>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", top: '-4vw', height: '12px' }}>
                                <Typography style={{ color: '#ffffff', fontSize: 36, position: "relative", top: "0vw", fontWeight: 'bold' }} >
                                    Machine
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ border: "3px dashed #4A4A49", borderRadius: 20, height: '150%' }}>

                                <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", top: '1vw', height: '12px' }}>
                                    {multiheadSKU?.VALUE === '0' ? '' :
                                        giveaway_rollout?.WARNING == 'ไม่ตรงแผนผลิต' || multiheadStatus?.VALUE == false
                                            ? <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="left" >
                                                <Typography style={{ color: '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '5%' }} >
                                                    {multiheadStatus?.VALUE == undefined ? '' : multiheadStatus?.VALUE == false ? <img src={Disconnected} height="25px" /> : ''}
                                                </Typography>
                                                <Typography style={{ color: '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '20%' }} >
                                                    &nbsp;&nbsp;Multihead:
                                                </Typography>
                                                <Typography style={{ color: sku_replace.split('\n').includes(multiheadSKU?.VALUE) ? '#2e9281' : '#8c0e0e', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '25%' }} >
                                                    &nbsp;{multiheadSKU?.VALUE == undefined ? '' : multiheadSKU?.VALUE}
                                                </Typography>
                                            </Box>
                                            : ''
                                    }

                                    {checkWeightSKU?.VALUE === '0' ? '' :
                                        giveaway_rollout?.WARNING == 'ไม่ตรงแผนผลิต' || checkWeightStatus?.VALUE == false
                                            ? <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="left" >
                                                <Typography style={{ color: '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '5%' }} >
                                                    {checkWeightStatus?.VALUE == undefined ? '' : checkWeightStatus?.VALUE == false ? <img src={Disconnected} height="25px" /> : ''}
                                                </Typography>
                                                <Typography style={{ color: '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '20%' }} >
                                                    &nbsp;&nbsp;Check Weight:
                                                </Typography>
                                                <Typography style={{ color: sku_replace.split('\n').includes(checkWeightSKU?.VALUE) ? '#2e9281' : '#8c0e0e', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '25%' }} >
                                                    &nbsp;{checkWeightSKU?.VALUE == undefined ? '' : checkWeightSKU?.VALUE}
                                                </Typography>
                                            </Box>
                                            : ''
                                    }

                                    {AICameraStatus?.VALUE == true
                                        ? <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="left" >
                                            <Typography style={{ color: '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '5%' }} >
                                                {AICameraStatus?.VALUE == undefined ? '' : AICameraStatus?.VALUE == true ? <img src={Disconnected} height="25px" /> : ''}
                                            </Typography>
                                            <Typography style={{ color: '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '20%' }} >
                                                &nbsp;&nbsp;AI Camera:
                                            </Typography>
                                            <Typography style={{ color: '#8c0e0e', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '21%' }} >
                                                &nbsp;
                                            </Typography>
                                        </Box>
                                        : ''
                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid id="top-row" container xs={4} md={4} lg={4} xl={4} style={{ position: "relative", padding: 3 }}>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", top: '-4vw', height: '12px' }}>
                                <Typography style={{ color: '#ffffff', fontSize: 36, position: "relative", top: "0vw", fontWeight: 'bold' }} >
                                    PO
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ border: "3px dashed #4A4A49", borderRadius: 20, height: '150%' }}>
                                <Grid id="top-row" container xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", top: '3.3vw' }}>
                                    <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center" style={{ position: "relative", top: '-2vw', height: '12px' }}>
                                        {
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                {sku_replace.split('\n').map((item, index) => {
                                                    const isMatch =
                                                        item === checkWeightSKU?.VALUE ||
                                                        item === multiheadSKU?.VALUE;

                                                    return (
                                                        <Typography key={index} style={{ color: isMatch ? '#2e9281' : '#ffffff', fontSize: 32, position: "relative", top: "0vw", fontWeight: 'bold', width: '100%', whiteSpace: 'pre-line' }} >
                                                            {item}
                                                        </Typography>
                                                    );
                                                })}
                                            </Box>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Backdrop>
        </div>
    );
}